var map = {
	"./img1_tablet.webp": 2021,
	"./img2_tablet.webp": 5418,
	"./img3_tablet.webp": 4003,
	"./img4_tablet.webp": 5584,
	"./img5_tablet.webp": 9233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8526;